import CheckboxSelectAll from 'stimulus-checkbox-select-all/dist/stimulus-checkbox-select-all.umd';

export default class extends CheckboxSelectAll {
  connect() {
    super.connect();
  }
}
